import React, { FC, HTMLAttributes } from 'react';
const ZeroScreen: FC<HTMLAttributes<HTMLDivElement>> = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="font-bold text-24">No Settlements till now</div>
      <div className="mt-13 font-medium text-black/60 text-16">
        All Settlements done by cashier will appear here
      </div>
    </div>
  );
};
export default ZeroScreen;
